<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button routerLink="/facilities/employeeDetails" routerLinkActive="active"
                (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Registeration</h1>
        </div>
    </div>
    <form>
        <div>
            <label for="emp_id"><br><b>Enter Employee ID</b> </label><br>
            <input [(ngModel)]="user.emp_id" #emp_id type="text">
            <div *ngIf="!validators[0]">
                <span id="validator">Invalid Employee ID</span>
            </div>
        </div>
        <div>
            <label for="phn_no"><br><b>Enter Phone No</b> </label><br>
            <input [(ngModel)]="user.phn_no" #phnno type="number">
            <div *ngIf="!validators[1]">
                <span id="validator">Invalid Phone no</span>
            </div>
        </div>
        <div>
            <label for="service_key"><br><b>Enter Unique Service Key</b> </label><br>
            <input #serviceKey type="text">
            <div *ngIf="!validators[3]">
                <span id="validator">Invalid Service Key</span>
            </div>
        </div>
        <div>
            <label for="mail"><br><b>Enter E-Mail Address</b> </label><br>
            <input [(ngModel)]="user.mail" #mail type="email">
            <div *ngIf="!validators[2]">
                <span id="validator">Invalid Mail ID</span>
            </div>
        </div>
        <div>
            <label for="pswd"><br><b>Enter Password</b></label><br>
            <input #pswd1 type="password">
            <div *ngIf="!validators[4]">
                <span id="validator">Invalid Password</span>
            </div>
        </div>
        <div>
            <label for="pswd"><br><b>Confirm Password</b></label><br>
            <input #pswd2 type="password">
            <div *ngIf="!validators[5]">
                <span id="validator">The passwords do not match</span>
            </div>
        </div>
        <br>
        <div>
            <input type="submit" value="Register"
                (click)="register(emp_id.value,phnno.value,serviceKey.value,pswd1.value,pswd2.value,mail.value)">
        </div>
    </form>
</div>